var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowSLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_543_44107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.222 19.4486C119.222 8.73037 110.519 0.0235596 99.7744 0.0235596H81.1823V38.8598H99.7744C110.505 38.8598 119.222 30.1667 119.222 19.4486Z",
    fill: "#FFC502"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1134 19.4486V0.0235596H41.0739V38.8598H59.666C70.3966 38.8598 79.0996 30.1667 79.0996 19.4486H79.1134Z",
    fill: "#FFC502"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2375 41.0503H40.9497V79.0461H79.2375V41.0503Z",
    fill: "#FFC502"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 38.0194V38.8598H38.9498V0.0235596H38.0395C17.0337 0.0235596 0 17.0377 0 38.0194Z",
    fill: "#FFC502"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.455154 100.565C0.455154 111.283 9.15818 119.99 19.8887 119.99H38.9222V81.1539H19.8887C9.15818 81.1539 0.455154 89.847 0.455154 100.579V100.565Z",
    fill: "#FFC502"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0739 100.565V119.99H79.1134V81.1539H60.5212C49.7907 81.1539 41.0876 89.847 41.0876 100.579L41.0739 100.565Z",
    fill: "#FFC502"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1685 119.976H81.8305C102.836 119.976 119.87 102.962 119.87 81.9805V81.1401H81.1685V119.976Z",
    fill: "#FFC502"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0809 79.1288H38.9222V41.1329H0.0413818C0.0413818 62.1147 17.075 79.1288 38.0809 79.1288Z",
    fill: "#FFC502"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9271 41.1329H81.0857V79.1288H119.967C119.967 58.147 102.933 41.1329 81.9271 41.1329Z",
    fill: "#FFC502"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_543_44107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119.953,
    height: 119.953,
    fill: "white",
    transform: "translate(0 0.0235596)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowSLogo);
export default __webpack_public_path__ + "static/media/YellowSLogo.3caff9db5fea6eec0bc4a7886a2741f0.svg";
export { ForwardRef as ReactComponent };